import { BookingRejectedError } from './BookingRejectedError';

export class MaxWeekendBookingsReachedError extends BookingRejectedError {
    constructor() {
        super('Alcanzaste el máximo de reservas permitidas para fines de semana.');
    }
}
